import React, { useState } from 'react';
import { useAppSelector } from '../../hooks/ReduxHooks';
import GfModal from '../../gfcomponents/GfModal/GfModal';
import { Checkbox } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { closeReopenFormWarning, reopenForm } from '../actions';
import { updateSettings } from '../../actions';

export interface FormStatusChangeModalProps {
  updateSettings: (settings: { skipFormStatusChangeWarning: boolean }) => void;
  reopenForm: (reopen: boolean) => void;
  closeReopenFormWarning: VoidFunction;
}

function FormStatusChangeModalComponent(props: FormStatusChangeModalProps) {
  const { skipFormStatusChangeWarning, reopenWarningOpen } = useAppSelector((state) => ({
    skipFormStatusChangeWarning: !!state.profile.settings?.skipFormStatusChangeWarning,
    reopenWarningOpen: !!state.formeditor.reopenWarningOpen
  }));

  const [checked, setChecked] = useState(skipFormStatusChangeWarning);

  function handleCheckboxChange() {
    const isChecked = !checked;
    setChecked(isChecked);
    props.updateSettings({ skipFormStatusChangeWarning: isChecked });
  }

  function handleReopenClick() {
    props.reopenForm(true);
    props.closeReopenFormWarning();
  }

  function handleCloseClick() {
    props.closeReopenFormWarning();
  }

  return (
    <GfModal
      className="formstatuschange-modal"
      title="Form Status Change Warning"
      primaryText="Reopen and change to Draft"
      secondaryText="Don't reopen"
      onPrimaryClick={handleReopenClick}
      onSecondaryClick={handleCloseClick}
      onClose={handleCloseClick}
      open={reopenWarningOpen}
    >
      <h3>Reopening a completed form will change its status to Draft.</h3>
      <div className="main-text">Workflow events may run again when the form is completed later.</div>
      <a href="https://help.goformz.com/en/articles/2484908-automating-form-workflows" target="_blank" rel="noopener noreferrer">
        Learn about managing events
      </a>
      <div>
        <Checkbox className="checkbox-field" label="Don't show me this next time" checked={checked} onClick={handleCheckboxChange} />
      </div>
    </GfModal>
  );
}

const FormStatusChangeModal = connect(null, { reopenForm, updateSettings, closeReopenFormWarning })(FormStatusChangeModalComponent);

export default FormStatusChangeModal;
